import React from "react";

import musicBackground from "../../static/img/Keyless Online.png";

function ImageAlt() {
  return (
    <>
      <div className="tw-hidden md:tw-flex tw-justify-center tw-ml-6 tw-mt-6 tw-border-b-[3px] tw-border-[#7685b7] sm:tw-w-full tw-w-2/3"></div>
      <div className="tw-hidden md:tw-flex tw-h-1/3 tw-w-2/3 tw-justify-center sm:tw-w-full -tw-z-10 tw-mt-6 tw-mb-5">
        <img
          src={musicBackground}
          alt="Music"
          className="tw-flex tw-justify-center tw-ml-8 sm:tw-ml-6 tw-object-cover tw-h-1/3 tw-w-5/6 tw-rounded-lg"
        />
      </div>
      <div className="tw-hidden md:tw-flex tw-justify-center tw-ml-6 tw-mt-6 tw-border-b-[3px] tw-border-[#7685b7] sm:tw-w-full tw-w-2/3"></div>
    </>
  );
}

export default ImageAlt;
